module.exports = __webpack_public_path__ + "assets/12a1ec4dc4f4fbafdbf1d2c6590964a5-DSC_0736.jpg";